import { render, staticRenderFns } from "./VehicleShiftsPage.vue?vue&type=template&id=499c3d64&scoped=true"
import script from "./VehicleShiftsPage.vue?vue&type=script&lang=js"
export * from "./VehicleShiftsPage.vue?vue&type=script&lang=js"
import style0 from "./VehicleShiftsPage.vue?vue&type=style&index=0&id=499c3d64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499c3d64",
  null
  
)

export default component.exports